export default __webpack_public_path__ + "static/media/tool_item_2_m.e8b38760.png";